import { Head } from "@inertiajs/react"
import { useState, useEffect } from "react"
import { TranscriptionStatusScreen } from "@/components/capture/TranscriptionStatusScreen"

interface TranscriptionJob {
  id: number
  file_name: string
  status: string
  submitted_at: string
  completed_at: string | null
  destination_path: string
  audio_duration: number | null
}

interface TranscriptionsData {
  processing: TranscriptionJob[]
  failed: TranscriptionJob[]
  completed: TranscriptionJob[]
}

function getCSRFToken(): string {
  const meta = document.querySelector('meta[name="csrf-token"]')
  return meta?.getAttribute("content") || ""
}

export default function Transcriptions() {
  const [data, setData] = useState<TranscriptionsData>({
    processing: [],
    failed: [],
    completed: [],
  })

  useEffect(() => {
    fetchData()
    const interval = setInterval(fetchData, 10000)
    return () => clearInterval(interval)
  }, [])

  async function fetchData() {
    try {
      const res = await fetch("/api/transcriptions", {
        headers: { "X-CSRF-Token": getCSRFToken() },
      })
      const json = await res.json()
      setData(json)
    } catch {
      // ignore
    }
  }

  async function handleRetry(id: number) {
    try {
      await fetch(`/api/transcriptions/${id}/retry`, {
        method: "POST",
        headers: { "X-CSRF-Token": getCSRFToken() },
      })
      fetchData()
    } catch {
      // ignore
    }
  }

  return (
    <>
      <Head title="Transcriptions" />
      <TranscriptionStatusScreen
        processing={data.processing}
        failed={data.failed}
        completed={data.completed}
        onRetry={handleRetry}
      />
    </>
  )
}
